(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/match-number-icon/assets/javascripts/match-number-icon.js') >= 0) return;  svs.modules.push('/components/tipsen/match-number-icon/assets/javascripts/match-number-icon.js');
"use strict";

const {
  ReactIcon: Icon
} = svs.ui;
const {
  matchNumberTextColor,
  matchNumberIconSize
} = svs.components.tipsen.matchNumberIcon.constants;
const MatchNumberIcon = _ref => {
  let {
    color,
    icon,
    size = matchNumberIconSize.MEDIUM,
    text,
    textColor = matchNumberTextColor.WHITE
  } = _ref;
  return React.createElement("div", {
    className: "pg_match_number_icon pg_match_number_icon--".concat(color, " pg_match_number_icon--").concat(size)
  }, React.createElement(Icon, {
    className: "pg_match_number_icon__icon",
    icon: icon
  }), text && React.createElement("span", {
    className: "pg_match_number__text pg_match_number__text--".concat(textColor)
  }, text));
};
setGlobal('svs.components.tipsen.matchNumberIcon.MatchNumberIcon', MatchNumberIcon);

 })(window);